
import JeeTestCriteria from 'components/JeeMockTest/JeeTestCriteria'
import JeeMockTestSeries from 'components/JeeMockTest/JeeMockTestSeries'
import JeeLegacySuccess from 'components/JeeMockTest/JeeLegacySuccess'
import JeeTestHighlight from 'components/JeeMockTest/JeeTestHighlight'
import JeeHowRegister from 'components/JeeMockTest/JeeHowRegister'

const JEEMockLandingTemplate = () => {
  return (
    <div>
      <JeeTestCriteria />
      <JeeMockTestSeries/>
      <JeeLegacySuccess/>
      <JeeTestHighlight/>
      <JeeHowRegister/>
    </div>
  )
}

export default JEEMockLandingTemplate